import dayjs from 'dayjs';

const byId = (a, b) => a.id - b.id;

const byCreatedDescent = (a, b) => dayjs(b.created) - dayjs(a.created);

export { byId, byCreatedDescent };
